var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7685 13.3473C6.6478 13.4533 6.4926 13.5117 6.332 13.5117C6.1714 13.5117 6.0162 13.4533 5.8955 13.3473C5.8944 13.345 5.8932 13.3416 5.8909 13.3394C5.8328 13.2898 5.7859 13.2282 5.7535 13.159C5.7211 13.0897 5.7039 13.0142 5.6907 12.9378L5.6907 5.06276C5.6907 4.90189 5.7603 4.75901 5.8977 4.65664L5.8955 4.65439C6.1374 4.43389 6.5278 4.43389 6.7685 4.65439L11.0522 8.60089C11.0988 8.65051 11.1442 8.71166 11.1759 8.78025C11.2069 8.84883 11.223 8.92327 11.223 8.99857C11.223 9.07388 11.2069 9.14831 11.1759 9.2169C11.1442 9.28548 11.0988 9.34663 11.0522 9.39626C11.0452 9.40189 11.036 9.40413 11.0203 9.40976L6.7685 13.3473Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/RightArrowIcon.7def8526530334723dd2735745f29dfb.svg";
export { ForwardRef as ReactComponent };